"use strict"

import Codec from "./codec"
import ElementCodec from "./element-codec"
import PointArrayCodec from "./point-array-codec"
import ColorCodec from "./color-codec"

import Highlight from "../ui/elements/highlight"

/**
 * Encodes/Decodes a highlight
 */
export default class HighlightCodec extends Codec {
  constructor() {
    super()
    this._pointsCodec = new PointArrayCodec()
    this._colorCodec = new ColorCodec()
  }

  /**
   * @param value {Highlight}
   * @returns {{data: Object, metadata: Object}}
   */
  encode(value) {
    let data = {
      type: value.type,
      color: this._colorCodec.encode(value.color),
      points: this._pointsCodec.encode(value.points),
      width: value.width,
    }
    return ElementCodec.firebaseElement(data, value.metadata)
  }

  /**
   * @param value {object}
   * @param key {string}
   * @returns {Highlight}
   */
  decode(value, key) {
    let metadata = ElementCodec.extractMetadata(value)

    return new Highlight(
      key,
      metadata,
      this._pointsCodec.decode(value.data.points),
      this._colorCodec.decode(value.data.color),
      value.data.width,
    )
  }
}
